import React from 'react';
import Container from '@material-ui/core/Container';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Settings from '@material-ui/icons/Settings';
import Save from '@material-ui/icons/Save';
import HighlightOff from '@material-ui/icons/HighlightOff';

import CustomTable from '../components/CustomTable';
import ModificaModelloManualeButton from '../components/ModificaModelloManualeButton';

import moment from 'moment';
import 'moment/locale/it';

import PropTypes from 'prop-types';

const styles = {
  root: {
    padding: '10px 10px',
  },
  formcontrol: {
    marginBottom: '30px',
    width: '136px',
  },
  // `.ReactTable .rt-td` carries `white-space: nowrap; overflow: hidden`, and its
  // `text-overflow` never shows here because the box that overflows is this div,
  // not the inline content of the td - so an unwrapped title is simply cut, with
  // no ellipsis, and this table cannot scroll sideways to reach the rest.
  cellaTesto: {
    whiteSpace: 'normal',
  },
};

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: '146px',
      width: '136px',
    },
  },
};

const dateTimeFormat = 'DD-MM-YYYY HH:mm';

export default function TabellaModelliGruppo(props) {
  const renderEditable = (record, fieldName) => {
    // titolo and regolamenti are NOT NULL in the schema, so the fallback is
    // defensive: it keeps a null from taking the screen down on a gear click,
    // which is what reading .trim() off one would do.
    const valore = record[fieldName] || '';
    if (props.edit === true && record.id === props.selectedRecordId) {
      return (
        <div
          style={{ backgroundColor: '#fafafa', ...styles.cellaTesto }}
          contentEditable
          suppressContentEditableWarning
          onBlur={(e) => {
            props.onEditedCell(record, fieldName, e.target.textContent);
          }}
        >
          {valore.trim().length === 0 ? '' : valore}
        </div>
      );
    }
    return <div style={styles.cellaTesto}>{valore}</div>;
  };

  const columns = [
    {
      Header: 'ID',
      id: 'id',
      accessor: (d) => d.id,
      width: 182,
    },
    {
      Header: 'ID modello di origine',
      id: 'manualeBaseId',
      accessor: (d) => d.manualeBaseId,
      width: 196,
    },
    {
      Header: 'Data ultima modifica',
      id: 'dataUltimoAggiornamento',
      sortable: false,
      filterable: false,
      accessor: (d) =>
        d.dataUltimoAggiornamento
          ? moment(d.dataUltimoAggiornamento)
              .locale('it')
              .format(dateTimeFormat)
          : '-',
      width: 196,
    },
    {
      Header: 'Titolo',
      id: 'titolo',
      accessor: (d) => d,
      minWidth: 120,
      Cell: (propCell) => renderEditable(propCell.value, 'titolo'),
    },
    {
      Header: 'Regolamenti',
      id: 'regolamenti',
      accessor: (d) => d,
      minWidth: 120,
      Cell: (propCell) => renderEditable(propCell.value, 'regolamenti'),
    },
    {
      Header: 'Stato',
      id: 'stato',
      sortable: false,
      filterable: false,
      resizable: false,
      accessor: (d) => d,
      width: 152,
      Cell: (propCell) => {
        if (propCell.value.stato === 'PUBBLICATO') {
          // The same typography the Select below renders its value with, so a
          // published row reads at the size a draft row does.
          return (
            <Typography variant="body1" style={styles.cellaTesto}>
              PUBBLICATO
            </Typography>
          );
        } else {
          return (
            <FormControl style={styles.formcontrol}>
              <Select
                value={propCell.value.stato}
                name="stato"
                disabled={props.edit === true}
                onChange={(event) => {
                  props.onStatoChanged(propCell.value, event);
                }}
                MenuProps={MenuProps}
              >
                <MenuItem value="PUBBLICATO">PUBBLICATO</MenuItem>
                <MenuItem value="BOZZA">BOZZA</MenuItem>
              </Select>
            </FormControl>
          );
        }
      },
    },
    {
      id: 'modifica',
      Header: 'Modifica',
      sortable: false,
      filterable: false,
      resizable: false,
      accessor: (d) => d,
      width: 80,
      Cell: (propCell) => {
        if (propCell.value.stato === 'BOZZA') {
          return (
            <IconButton
              style={{ color: props.theme.palette.primary.main }}
              size="small"
              onClick={(e) => {
                props.edit && propCell.value.id === props.selectedRecordId
                  ? props.onSave(propCell.value, e)
                  : props.onEdit(propCell.value, e);
              }}
            >
              {props.edit && propCell.value.id === props.selectedRecordId ? (
                <Save />
              ) : (
                <Settings />
              )}
            </IconButton>
          );
        } else {
          return (
            <IconButton size="small" disabled>
              <Settings />
            </IconButton>
          );
        }
      },
    },
    {
      id: 'modificaContenuto',
      Header: 'Modifica contenuto',
      sortable: false,
      filterable: false,
      resizable: false,
      width: 170,
      accessor: (d) => d,
      Cell: (propCell) => (
        <ModificaModelloManualeButton
          modelloId={propCell.value.id}
          disabled={propCell.value.stato === 'PUBBLICATO' ? true : false}
        />
      ),
    },
    {
      id: 'elimina',
      Header: 'Elimina',
      sortable: false,
      filterable: false,
      resizable: false,
      accessor: (d) => d,
      width: 80,
      Cell: (propsCell) => (
        <IconButton
          style={{ color: props.theme.palette.primary.main }}
          size="small"
          onClick={(e) => props.onElimina(propsCell.value, e)}
        >
          <HighlightOff />
        </IconButton>
      ),
    },
  ];
  return (
    <Container maxWidth={false} style={styles.root}>
      <CustomTable
        columns={columns}
        records={props.modelli}
        loading={false}
        filterable={true}
        resizable={true}
        sortable={true}
        defaultPageSize={5}
      />
    </Container>
  );
}

TabellaModelliGruppo.propTypes = {
  theme: PropTypes.object.isRequired,
  modelli: PropTypes.array.isRequired,
  selectedRecordId: PropTypes.number,
  edit: PropTypes.bool.isRequired,
  onStatoChanged: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onEditedCell: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onElimina: PropTypes.func.isRequired,
};
